// https://github.com/FlutterInt/fips-shared-protocols/blob/master/lobby.h

// prettier-ignore
enum AwardScheme {
  PRIZE_ANOTHER_TOURN = 1,                // winners go to another tournament
  PRIZE_MONEY_PERCENT = 2,                // winners receive money
  PRIZE_MONEY_AND_ANOTHER_TOURN = 3,      // specified number of winners goes to another tourn. winners receive money
  PRIZE_ANOTHER_TOURN_FPP = 4,            // winners go to another tournament, fppBuyIn != 0
  PRIZE_TOURN_TICKETS = 5,                // winners get tickets (and perhaps $$+%)
  PRIZE_CHIPS_PROPORTIONAL = 6,           // winners get buy-in + money proportional to chips.
  PRIZE_NEXT_FLIGHT_TOURN = 7,            // winners to go to the next flight tournament, #19167
}

export default AwardScheme;
